/**
 * Safely casts a Contentful Entry's fields to a known type.
 * The Contentful SDK uses complex union types internally; this helper avoids
 * repeating `as unknown as T` at every call site.
 */
export function fields<T>(entry: { fields: unknown }): T {
  return entry.fields as T;
}
